<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-text">
                    <h2>CONTACTEZ-NOUS</h2>
                    <ul>
                        <li><a routerLink="/">ACCUEIL</a></li>
                        <li><i class="icofont-simple-right"></i></li>
                        <li>CONTACTEZ-NOUS</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container pt-100 pb-170">
  <div class="contact-content">
    <div class="container">
      <div class="contact-info-container">
        <!-- Informations de contact -->
        <div class="contact-info">
          <div class="info-card">
            <div class="info-icon">
              <i class="icofont-location-pin"></i>
            </div>
            <div class="info-content">
              <h3>Adresse</h3>
              <p>123 Avenue de la République<br>Conakry, Guinée</p>
            </div>
          </div>

          <div class="info-card">
            <div class="info-icon">
              <i class="icofont-email"></i>
            </div>
            <div class="info-content">
              <h3>Email</h3>
              <p><a href="mailto:contact@qualifpme.com">contact@qualifpme.com</a></p>
              <p><a href="mailto:support@qualifpme.com">support@qualifpme.com</a></p>
            </div>
          </div>

          <div class="info-card">
            <div class="info-icon">
              <i class="icofont-phone"></i>
            </div>
            <div class="info-content">
              <h3>Téléphone</h3>
              <p><a href="tel:+22412345678">+224 123 456 78</a></p>
              <p><a href="tel:+22498765432">+224 987 654 32</a></p>
            </div>
          </div>

          <div class="social-links">
            <h3>Suivez-nous</h3>
            <div class="social-icons">
              <a [href]="appSettingService.value.facebook_url" class="social-icon" aria-label="Facebook"><i class="icofont-facebook"></i></a>
              <a [href]="appSettingService.value.youtube_url" class="social-icon" aria-label="Youtube"><i class="icofont-youtube-play"></i></a>
              <a [href]="appSettingService.value.twiter_url" class="social-icon" aria-label="Twitter"><i class="icofont-twitter"></i></a>
              <a [href]="appSettingService.value.instagram_url" class="social-icon" aria-label="Instagram"><i class="icofont-instagram"></i></a>
            </div>
          </div>
        </div>
      </div>

      <!-- Carte Google Maps élargie -->
      <div class="map-container full-width">
        <h2>Où nous trouver</h2>
        <div class="map-wrapper">
          <iframe 
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3934.320095417701!2d-13.664550610513777!3d9.567650966065095!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xf1cd731e9df587f%3A0xa2f8cb019f00b3c6!2sBourse%20de%20Sous-Traitance%20et%20de%20Partenariats%20-%20Guin%C3%A9e!5e0!3m2!1sen!2sbd!4v1729764681148!5m2!1sen!2sbd" 
            width="100%" 
            height="500" 
            style="border:0;" 
            allowfullscreen="" 
            loading="lazy" 
            referrerpolicy="no-referrer-when-downgrade">
          </iframe>
        </div>
      </div>
    </div>
  </div>
</div>